import * as React from "react";
const SvgFiRrCrutch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-crutch_svg__a)">
      <path
        fill="#062147"
        d="M23.475 8.12c-.02-.01-2.076-1.136-4.19-3.25C17.16 2.745 15.883.527 15.87.505a1 1 0 0 0-1.738.99c.02.034.191.333.5.803L9.015 7.915a10.22 10.22 0 0 0-3.014 7.275v1.395L.293 22.293a.999.999 0 1 0 1.414 1.414L7.414 18H8.81c2.748 0 5.332-1.07 7.275-3.014l5.608-5.608c.491.316.8.484.834.502a1.002 1.002 0 0 0 1.354-.405 1 1 0 0 0-.405-1.354M8 16v-.809c0-1.877.62-3.659 1.763-5.112l4.16 4.158A8.23 8.23 0 0 1 8.81 16zm7.378-3.135-4.243-4.243 4.678-4.678c.56.72 1.25 1.532 2.058 2.34A24 24 0 0 0 20.042 8.2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-crutch_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCrutch;
